import React from "react";
import { Outlet } from "react-router-dom";

function MainRenewal() {
  return (
    <div>
      <Outlet />
    </div>
  );
}

export default MainRenewal;
